import React, { useCallback } from "react";
import { useTheme } from "../context/ThemeContext";

const CustomSelect = ({ data, value, onChange }) => {
  const handleOnChange = useCallback((e) => {
    //    setValue(e.target.value)
    onChange?.(e.target.value);
  }, [onChange]);
  const {theme} = useTheme();
  return (
    <select
      className={`inline-flex outline-none items-center rounded-lg px-2.5 py-1 text-[14px] font-medium transition-colors duration-200 ${theme==='light'?'bg-gray-100 text-gray-900 hover:bg-gray-200':'bg-gray-800 text-gray-100 hover:bg-gray-700'}`}
      value={value}
      onChange={handleOnChange}
    >
      {data?.map((el) => (
        <option key={el.id} value={el.value}>
          {el.name}
        </option>
      ))}
    </select>
  );
};

export default CustomSelect;
